import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for existing token on mount
    const checkAuth = async () => {
      const token = localStorage.getItem('auth_token');
      if (token) {
        try {
          const response = await fetch(`${BACKEND_URL}/api/auth/verify-token?token=${token}`);
          if (response.ok) {
            const data = await response.json();
            setUser(data.user);
            setIsAuthenticated(true);
          } else {
            localStorage.removeItem('auth_token');
          }
        } catch (error) {
          console.error('Auth check failed:', error);
          localStorage.removeItem('auth_token');
        }
      }
      setLoading(false);
    };

    checkAuth();
  }, []);

  const signIn = (userData) => {
    setUser(userData);
    setIsAuthenticated(true);
  };

  const signUp = (userData) => {
    setUser(userData);
    setIsAuthenticated(true);
  };

  const signOut = () => {
    localStorage.removeItem('auth_token');
    setUser(null);
    setIsAuthenticated(false);
  };

  const logout = signOut; // Alias for compatibility

  return (
    <AuthContext.Provider value={{ user, isAuthenticated, loading, signIn, signUp, signOut, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
